/// <amd-module name="Wiki/Filter/WikiFilterService" />
import { Services, VssService } from "VSS/Platform/Context";
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { IWikiPageFilterStrategy } from "Wiki/Filter/Contracts";
import { IWikiFilterService } from "Wiki/Filter/IWikiFilterService";
import { LinearFilterStrategy } from "Wiki/Filter/LinearFilterStrategy";
import { FilteredWikiPage } from "Wiki/PageTree/Contracts";

export class WikiFilterService extends VssService implements IWikiFilterService {
    private _filterStrategy: IWikiPageFilterStrategy;

    constructor() {
        super();
        this._filterStrategy = new LinearFilterStrategy(); // TODO: telementry options
    }

    public setAllPages(allItems: WikiPage[]): void {
        this._filterStrategy.setAllFilterItems(allItems);
    }

    public filter(queryText: string): FilteredWikiPage[] {
        return this._filterStrategy.filter(queryText);
    }
}

Services.add("wiki-filter-service", { serviceFactory: WikiFilterService });
